module.exports = __webpack_public_path__ + "static/media/IMG_3477_sm.05c350ad.jpg";